import axios from "axios";
import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import React from "react";

import CONSTANTS from "../utils/constants";
import { encrypt } from "../utils/crypt";
import General from "../../src/stores/GeneralStore";

import { ErrorWrapper } from "../utils/ErrorWrapper";
import { NotifyError } from "../utils/ShowError";
import { NotifySuccess } from "../utils/ShowSuccess";
import generalStore from "../../src/stores/GeneralStore";
import { IValidatePassword } from "../../src/interfaces/IValidatePassword";
import { fetchDeviceInfo } from "../../src/utils/authHelper";
import { IMfaRequest } from "../interfaces/IMfaRequest";

interface Obj {
  [key: string]: any;
}

type BankDetails = {
  customerName: string;
  bankAccountNumber: string;
  ibanNumber: string;
  swiftCode: string;
  bankBranchName: string;
  bankType: string;
  bankName: string;
  country: string;
};
const notify = (message: any) => toast(message);
class User {
  initialInfo: Obj = {};
  loginInfo: Obj = {};
  info: Obj = {};
  profile: Obj = {};
  servesis: Obj = {};
  uaePassDetails: Obj = {};
  uaePassConfigDetails: Obj = {};
  favourites: Obj[] = [];
  isPopUpOpen: boolean = false;
  bankData: Obj = {};
  poBoxData: Obj = {};
  ownerMovein: Obj = {};
  loginError: string = "";
  documentsResponse: Obj = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    makePersistable(this, {
      name: "User",
      properties: ["info", "uaePassDetails", "favourites", "profile"],
      storage: window.localStorage,
    });
  }
  clearCache = () => {
    this.ownerMovein = {};
  };

  persistLoginInfo = () => {
    window.localStorage.setItem("user", JSON.stringify(this.info));
    window.localStorage.setItem("us_tkn", this.info.token);
    window.localStorage.setItem("username", this.info.userName);
  };

  login = ErrorWrapper(async (data: Obj) => {
    const EXCLUDED = new Set(["recaptchaToken", "platform", "sessionData"]);

    function buildEncData<T extends Record<string, any>>(data: T) {
      const encData: Record<string, any> = {};

      for (const [key, val] of Object.entries(data)) {
        if (EXCLUDED.has(key)) {
          encData[key] = val;
        } else {
          encData[key] = encrypt(val as any);
        }
      }

      return encData;
    }

    // usage
    const encData = buildEncData(data);

    this.loginInfo = encData;
    try {
      this.loginError = "";
      await axios.post(CONSTANTS.URL.USER_LOGIN, encData).then((res) => {
        this.initialInfo = res.data.result;
      });
    } catch (error: any) {
      let message = error?.response?.data?.error?.[0]?.message || error?.response?.data?.message;
      
      if (message === "RecaptchaError") {
        this.loginError =  message;
        NotifyError(message);
      } else {
        NotifyError(
          message
        ? General?.codeLabels[message]?.label
        : General?.codeLabels["cm_mob_usecsslogin"]?.label
        );
      }
    }
  });

  verifyOTPAndLogin = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VERIFY_OTP_AND_LOGIN,
      type: "POST",
      data,
    });

    runInAction(() => {
      console.log(res.result);
      // this.otpResult = res.result;
      this.initialInfo = res.result;
    });
    return res;
  });

  loginUaePass = ErrorWrapper(async (data: Obj) => {
    try {
      await axios.post(CONSTANTS.URL.USER_LOGIN, data).then((res) => {
        this.info = res.data.result;
      });
    } catch (error: any) {
      var message = error?.response?.data?.error[0]?.message;

      NotifyError(
        message
          ? General?.codeLabels[message]?.label
          : General?.codeLabels["cm_mob_usecsslogin"]?.label
      );
    }
  });

  // register =ErrorWrapper( async (payload: object) => {
  //   const data={
  //     ...payload,
  //     accountNumber:General?.premise?.ownerAccount?.accountNumber,
  //     personId:General?.premise?.ownerAccount?.personId,
  //   }
  //   try {
  //     await axios.post(CONSTANTS.URL.REGISTER_USER, data).then((res:any) => {
  //       window.localStorage.setItem("user", JSON.stringify(res.data.result));
  //       window.localStorage.setItem("us_tkn", res.data.result.token);
  //       window.localStorage.setItem("username", res.data.result.userName);
  //       runInAction(() => {
  //         this.ownerMovein = res?.result;
  //       });
  //       console.clear();
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // })
  checkLogin = ErrorWrapper(async (payload: any) => {
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.CHECK_LOGIN,
        type: "POST",
        data: payload,
      });

      return res.result;
    } catch (error: any) {
      const message = error?.error[0]?.message;
      NotifyError(
        message
          ? General?.codeLabels[message]?.label
          : General?.codeLabels["cm_mob_usecsslogin"]?.label
      );
    }
  });
  register = ErrorWrapper(async (payload: object) => {
    const data = {
      ...payload,
      // accountNumber: General?.premise?.ownerAccount?.accountNumber,
      // personId: General?.premise?.ownerAccount?.personID,
      // registraionType: "Default Account",
    };
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.REGISTER_USER,
        type: "POST",
        data,
      });
      runInAction(() => {
        this.ownerMovein = res?.result;
      });
      return res;
    } catch (error: any) {
      if (
        error?.error[0]?.message == "cm_usernamenotfree" ||
        error?.error[0]?.message == "cm_nu_per_alrdy"
      ) {
        NotifyError(General?.codeLabels["cm_usernamenotfree"].label);
      } else {
        const msg = error?.error[0]?.propertyName;
        var label = msg?.split("|")?.[0]?.toLowerCase();
        const userName = msg?.split("|")?.[1];
        const notiyError = General?.codeLabels[label]?.label?.replace(
          "%1",
          userName
        );
        NotifyError(notiyError);
      }
    }
  });
  uaePassLoginNOEID = ErrorWrapper(async (payload: object) => {
    const data = {
      ...payload,
    };
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.UAE_PASS_NO_EID,
        type: "POST",
        data,
      });
      console.log(res);
      window.localStorage.setItem("user", JSON.stringify(res?.result));
      window.localStorage.setItem("us_tkn", res?.result.token);
      window.localStorage.setItem("username", res?.result.userName);
      runInAction(() => {
        this.info = res?.result;
      });
      return res;
    } catch (error: any) {
      const errorMessage = error?.error[0]?.message
        ? error?.error[0]?.message
        : General?.codeLabels["cm_mob_servrerr"]?.label;
      NotifyError(errorMessage);
    }
  });
  getProfile = async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_PROFILE(personId),
    });

    runInAction(() => {
      this.profile = res.result;
    });
    return res;
  };
  getBankData = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.BANK_DATA(personId),
    });

    runInAction(() => {
      this.bankData = res.result;
    });
    return res.result;
  });
  getSwiftCode = ErrorWrapper(async (lang: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SWIFT_CODE(lang),
    });
    return res;
  });
  userNameRes = async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_USERNAME,
      type: "GET",
      data: {
        personId: personId,
      },
    });
    runInAction(() => {
      // this.profile = res?.result?.personId;
    });
    return res;
  };

  redirectUAEPass = async ({
    code,
    state,
  }: {
    code: string;
    state: string;
  }) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UAE_REDIRECT(code, state),
    });

    runInAction(() => {
      this.uaePassDetails = res.result;
    });
  };
  uaeGetConfig = async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UAE_CONFIG_DETAILS,
    });

    runInAction(() => {
      this.uaePassConfigDetails = res?.result;
    });
  };

  getFavourites = async () => {
    const currentLan: any =
      localStorage.getItem("settingUplanguage") ?? "en-US";
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.FAVOURITES(currentLan),
    });
    // console.log("favourites", res);
    runInAction(() => {
      this.favourites = res.data;
    });
  };
  getServesis = async () => {
    const currentLan: any =
      localStorage.getItem("settingUplanguage") ?? "en-US";
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.ALL_SERVICES(currentLan),
    });
    // console.log("favourites", res);
    runInAction(() => {
      this.servesis = res.data;
    });
  };

  addFavourite = async (serviceId: string) => {
    const currentLan: any =
      localStorage.getItem("settingUplanguage") ?? "en-US";
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.ADD_FAVOURITE(serviceId, currentLan),
      type: "POST",
    });

    this.getFavourites();
  };

  removeFavourite = async (serviceId: string) => {
    const currentLan: any =
      localStorage.getItem("settingUplanguage") ?? "en-US";
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.REMOVE_FAVOURITE(serviceId, currentLan),
      type: "POST",
    });

    this.getFavourites();
  };

  forgotPassword = ErrorWrapper(async (username: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.FORGOT_PASSWORD,
      type: "POST",
      data: { username },
    });
    if (res?.message == "Success") {
      const message = General?.codeLabels[res?.result?.message]?.label;
      NotifySuccess(message);
    }
    return res;
  });

  forgotUserName = ErrorWrapper(async (data: Obj) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.FORGOT_USERNAME,
      type: "POST",
      data: { email: data?.email, accountId: data?.account },
    });
        const message = General?.codeLabels[res?.result?.fieldName]?.label;
        NotifySuccess(message);

  
    return res;
  });
  resetPassword = ErrorWrapper(async (data: Obj) => {
    // let encData: any = {};
    // for (let key in data) {
    //   encData[key] = encrypt(data[key] as any);
    // }
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.RESET_PASSWORD,
      type: "POST",
      data,
    });
    if (res?.message == "Success") {
      const message = General?.codeLabels[res?.result?.message]?.label;
      // NotifySuccess(message);
    }
    return res;
  });

  verifyEmail = ErrorWrapper(async (data: Obj) => {
    try {
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.VERIFY_EMAIL,
        type: "POST",
        data,
      });
      return res;
    } catch (error: any) {
      const msg = error?.error[0]?.message;
      NotifyError(
        generalStore?.codeLabels["msg"]?.label
          ? generalStore?.codeLabels["msg"]?.label
          : "User not found"
      );
    }
  });

  updateProfile = ErrorWrapper(async (dataa: ProfileUpdateData) => {
    try {
      const data = JSON.stringify(dataa);
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.UPDATE_PROFILE(this.info.personId),
        type: "POST",
        data,
      });
      if (res?.message == "Success") {
        const message = General?.codeLabels[res?.result?.message]?.label;
        NotifySuccess(message);
      }
      runInAction(() => {
        this.profile = res.result;
      });
      return res;
    } catch (error) {
      return false;
    }
  });
  updatePobox = ErrorWrapper(async (data: ProfileUpdateData) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPDATE_POBOX(this.info.personId),
      type: "POST",
      data,
    });
    return res;
  });
  deleteAccount = ErrorWrapper(
    async ({
      personId,
      transactionId,
    }: {
      personId: string;
      transactionId: string;
    }) => {
      console.log(personId, transactionId);
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.DELETE_ACCOUNT(personId, transactionId),
        // type: "POST",
      });
      return res;
    }
  );
  getPoboxData = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPDATE_POBOX(personId),
    });
    runInAction(() => {
      this.poBoxData = res.result?.cmPerson_IWS;
    });
    return res.result?.cmPerson_IWS;
  });
  getServerPolicyVersion = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SERVER_POLICY_VERSION,
    });
    console.log("Server Policy Version", CONSTANTS.URL.SERVER_POLICY_VERSION);
    return res;
  });
  getConsentHtml = ErrorWrapper(async (type: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CONSENT_HTML(type),
      // type: "POST",
    });
    return res;
  });
  postDataConsent = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.POST_CONSENT,
      type: "POST",
      data,
    });
    return res;
  });
  removePoBoxData = () => {
    this.poBoxData = {};
  };
  updateContactDetails = ErrorWrapper(
    async ({
      emailId,
      mobileNumber,
      oldMobileNumber,
      mode,
      transactionId,
    }: {
      emailId: string;
      mobileNumber: string;
      oldMobileNumber: string;
      mode: string;
      transactionId: string;
    }) => {
      const data = {
        mode,
        personId: this.info.personId,
        emailId,
        mobileNumber,
        oldMobileNumber,
        transactionId,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.UPADTE_CONTACT_DETAILS,
        type: "POST",
        data,
      });

      // runInAction(()=>{this.contactDetails = res.data})
      return res;
    }
  );

  updateBankDetails = ErrorWrapper(async (data: BankDetails) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPDATE_BANK_DETAILS(this.info.personId),
      type: "POST",
      data,
    });
    // notify(res?.result?.cmRefundBankAccountService?.output?.statusMessage);
    if (res?.result?.cmRefundBankAccountService?.output?.status == "F") {
      NotifyError(
        res?.result?.cmRefundBankAccountService?.output?.statusMessage
      );
    }
    console.log(res?.result?.cmRefundBankAccountService);
    if (res?.result?.cmRefundBankAccountService?.output?.status == "S") {
      if (res?.result?.cmRefundBankAccountService?.input?.action == "DELETE") {
        NotifySuccess(General?.codeLabels["cm_del_bank_header"]?.label);
      } else {
        NotifySuccess(General?.codeLabels["cm_saved"]?.label);
      }
    }
    runInAction(() => {
      this.bankData = res.result;
    });
    return res;
  });

  updateDocuments = ErrorWrapper(async (files: any) => {
    // const res = await callRemoteMethod({endpoint: CONSTANTS.URL.UPDATE_DOCUMENTS, type: 'POST', files});
  });

  setUserInfo = () => {
    this.info = this.initialInfo;
    this.initialInfo = {};
  };

  uploadDocuments = ErrorWrapper(
    async ({
      files,
      customerMessage,
      orderId,
      action,
      UploadType,
      UploadScreen,
      key,
    }: {
      files: any;
      customerMessage: string;
      orderId: string;
      action: string;
      UploadType: string;
      UploadScreen: string;
      key: string;
    }) => {
      const dataFiles = {
        data: {
          orderId,
          customerMessage,
          action,
          UploadType,
          UploadScreen,
          key,
        },
        multiFileUpload: files,
      };
      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.UPLOAD_DOCUMENTS,
        type: "POST",
        data: dataFiles,
      });

      runInAction(() => {
        this.documentsResponse = res;
      });
    }
  );

  logout = async () => {
    this.info = {};
    this.initialInfo = {};
    this.profile = {};
    this.uaePassDetails = {};
    this.favourites = [];
    this.bankData = {};
    this.isPopUpOpen = false;
    // RemoveSessionCookie();

    localStorage.removeItem("general");
    localStorage.removeItem("username");
    localStorage.removeItem("us_tkn");
    localStorage.removeItem("User");
    localStorage.removeItem("user");
  };

  /**
   * Checks if the provided reset password link code is valid.
   * @param code - The unique reset link code.
   * @returns A response indicating the validity of the link.
   */
  isValidLink = async (code: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.IS_VALID_RESET_LINK(code),
      type: "Get",
    });
    return res;
  };

  /**
   * Validates the strength and format of the provided password.
   * @param data - The password validation data payload.
   * @returns A response indicating whether the password is valid.
   */
  validatePassword = ErrorWrapper(async (data: IValidatePassword) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.IS_VALID_PASSWORD,
      type: "POST",
      data,
    });

    return res;
  });

  /**
   * Updates the MFA status for the given person.
   * @param personId - The identifier of the user whose MFA status is to be updated.
   * @returns A response indicating success/failure of the update.
   */
  updateMFAStatus = ErrorWrapper(async ({ personId }: { personId: string }) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPDATE_MFA_STATUS(personId),
      type: "POST",
    });

    return res;
  });

  /**
   * Registers the current device session by sending device info to the server.
   * @returns A response indicating success/failure of session save.
   */
  saveUserSession = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SAVE_USER_SESSION,
      type: "POST",
      data: await fetchDeviceInfo(personId),
    });

    return res;
  });

  /**
   * Determines whether MFA is required for the current device and IP.
   * @param data - The device session info (deviceId and ipAddress).
   * @returns A boolean flag in the response indicating if MFA is required.
   */
  isMFARequired = ErrorWrapper(async (data: IMfaRequest) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.IS_MFA_REQUIRED,
      type: "POST",
      data,
    });

    return res.requiresMFA;
  });

  downloadProfile = async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.DOWNLOAD_PROFILE(personId),
      file: true,
    });

    console.log(res);
    return res;
  };
}

const userStore = new User();

export default userStore;

export type ProfileUpdateData = {
  isUAEPASSEnabled?: boolean;
  // poBox: string;
  // emirate: string;
  email: string;
  mobileNumber: string;
  dob: string;
  gender: Obj;
  nationality: Obj;
  language: Obj;
  alternateEmail?: string;
  favouriteServiceDeliveryChannel: Obj;
  favouritePaymentChannel: Obj;
  morning: boolean;
  afternoon: boolean;
  evening: boolean;
};
